<div [ngStyle]="style">
  <!-- <ngx-codemirror
    #codemirror
    [options]="codeMirrorOptions"
    [(ngModel)]="yaml"
    (ngModelChange)="contentHasChanged()"
  >
  </ngx-codemirror> -->
</div>

